import { ucfirst } from "@global/actions";
import ActivityDetail from "./ActivityDetail";
import TransferDetail from "./TransferDetail";
import HotelDetail from "./HotelDetail";
import StandarDetail from "./StandarDetail";
const LoadComponent = (props) => {
  switch (ucfirst(props.product.service)) {
    case "Activity":
      return <ActivityDetail {...props} />;
    case "Transfer":
      return <TransferDetail {...props} />;
    case "Hotel":
      return <HotelDetail {...props} />;
    default:
      return <StandarDetail {...props} />;
      break;
  }
};

export default LoadComponent;
